import React, { forwardRef, useRef } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  IconButton,
  InputGroup,
  InputRightElement,
  useDisclosure,
  useMergeRefs,
  Flex,
  Tooltip,
  Icon,
} from "@chakra-ui/react";
import {
  white,
  newBorder,
  textPrimary,
  backgroundLight,
  primaryAlt,
} from "../../utils/colors";
// import PasswordInput from "./PasswordInput";

import { HiEye, HiEyeOff } from "react-icons/hi";
import { shade } from "polished";
import { FaCircleInfo } from "react-icons/fa6";

const FormControlPassword = forwardRef(
  (
    {
      isRequired,
      label,
      labelFontSize,
      value,
      placeholder,
      onChange,
      isTouched,
      isError,
      w,
      errorMessage,
      explainTooltip,
      explainTooltipLabel,
      rightLabelElement,
    },
    ref
  ) => {
    const { isOpen, onToggle } = useDisclosure();
    const inputRef = useRef(null);
    const mergeRef = useMergeRefs(inputRef, ref);
    const onClickReveal = () => {
      onToggle();
      if (inputRef.current) {
        inputRef.current.focus({ preventScroll: true });
      }
    };

    return (
      <FormControl
        mb={4}
        isRequired={isRequired}
        isInvalid={isTouched && isError}
        w={w}
      >
        <FormLabel
          fontSize={labelFontSize ? labelFontSize : "sm"}
          position="relative"
          color={textPrimary}
        >
          {label ? (
            <Box align="center" width="initial" display="inline-block">
              <Flex align="center">
                {label}
                {explainTooltip && (
                  <Tooltip
                    p="0.5rem 1rem"
                    placement="top"
                    borderRadius="1rem"
                    label={explainTooltipLabel ? explainTooltipLabel : "-"}
                  >
                    <Flex
                      align="center"
                      ml={1}
                      color={shade(0.3, backgroundLight)}
                      _hover={{ cursor: "pointer", color: primaryAlt }}
                    >
                      <Icon as={FaCircleInfo} fontSize="0.875rem" />
                    </Flex>
                  </Tooltip>
                )}
              </Flex>
            </Box>
          ) : null}

          {isError && isTouched && (
            <Box position="absolute" top={-1} right={0} zIndex={2}>
              <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
            </Box>
          )}

          {rightLabelElement && (
            <Box position="absolute" top={0} right="-0.5rem" zIndex={2}>
              {rightLabelElement}
            </Box>
          )}
        </FormLabel>
        <InputGroup align="center">
          <Input
            value={value}
            onChange={onChange}
            bg={white}
            placeholder={placeholder}
            id="password"
            ref={mergeRef}
            name="password"
            type={isOpen ? "text" : "password"}
            autoComplete="new-password"
            color={textPrimary}
            required
            size="lg"
            // h="3.5rem"
            border={`1px solid ${newBorder}`}
            borderRadius="0.75rem"
            boxShadow="none !important"
            fontSize={["1rem", "0.938rem"]}
            fontWeight="500"
          />
          <InputRightElement h="100%" w="3.5rem">
            <IconButton
              tabIndex={-1}
              variant="text"
              aria-label={isOpen ? "Mask password" : "Reveal password"}
              icon={isOpen ? <HiEyeOff /> : <HiEye />}
              onClick={onClickReveal}
              color={textPrimary}
            />
          </InputRightElement>
        </InputGroup>

        {/* <Input
        type={type}
        bg={white}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        size={isSmall ? "md" : "lg"}
        fontSize={isSmall ? "sm" : "0.938rem"}
        fontWeight="500"
        color={textPrimary}
        border={`1px solid ${newBorder}`}
        borderRadius="0.75rem"
        boxShadow="none !important"
      /> */}
      </FormControl>
    );
  }
);

export default FormControlPassword;
